import React, { useState, useEffect, useRef } from 'react'
import style from './IndexView.scss'
import { api } from '../../../../common/app'
import { Grid, Icon } from "antd-mobile";
import { useHistory } from 'react-router-dom';
import { useUserStatus } from '../../../../common/hooks/user-status';


export default (props: any) => {
  let params = props.match.params;
  const { setHidden } = props;
  const history = useHistory();
  const iconContainer: any = useRef(null);
  const [meetingid, setMeetingid] = useState(undefined);
  const [meetinginfo, setMeetinginfo] = useState({} as any);
  const [register, setRegister] = useState("unregistered");
  const [modelList, setModelList] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [iconWidth, setIconWidth] = useState(-1);
  const [showRegisterButton, setShowRegisterButton] = useState(true);
  const [bottomImage, setBottomImage]=  useState({}  as any);

  // 全局status
  const {
      dispatch,
      actionTypes,
      userstatus,
      refreshUserstatus,
  } = useUserStatus(params.id);

  /**
   * 判断开关列表跳转到对应页面
   */
  useEffect(() => {
    if (!!params.id) {
      (api as any).showButton({ meetid: params.id }).then((result: any) => {
        console.log('result', result);
        if (result.code !== 200) {
          return;
        }

        dispatch({
          type: actionTypes.update,
          payload: result.result
        })

        // 会议开启了注册
        if (result.result.is_register === false) {
          setShowRegisterButton(false);
          setHidden(true)
        }
      }).catch((err: any) => {
        console.log('err', err);
      });
    }
  }, [params.id]);

  // 查询会议广告
  useEffect(() => {
    if (params.id) {
      // @ts-ignore
      api.getButtonImg({meetid: params.id})
        .then((result: any) => {
          if (result.code === 200) {
            setBottomImage(result.result);
          }
        })
    }
    
  }, [params.id]);

  useEffect(() => {
    if (meetingid !== params.id) {
      setMeetingid(params.id);
      getIndexInfo(params.id);
      getIsApply(params.id);
      getModelList(params.id);
    }
  }, [meetingid, params.id]);

  const getIndexInfo = (id: any) => {
    (api as any).getMeetingIndex(id).then((res: any) => {
      console.log(res);
      if (res.code === 200) {
        setMeetinginfo(res.result);
        document.title = res.result.title ?? "会佰分";
      }
    }, (err: any) => {
      console.log(err);
    })
  }
  const getIsApply = (id: any) => {
    (api as any).getIsApply(id).then((res: any) => {
      if (res.code === 200) {
        setRegister(res.result.status);
      }
    }, (err: any) => {
      console.log(err);
    })
  }
  const getModelList = (id: any) => {
    (api as any).getModelList(id).then((res: any) => {
      setModelList(res.result);
    }, (err: any) => {
      console.log(err);
    })
  }
  const onRegister = async () => {
    const status = await refreshUserstatus();
    if (status.user_is_register === true) {
      history.push(`/mine/index/${params.id}`);
      return;
    }
    history.push(`/home/register/${params.id}`);
  }

  const iconstyle = bottomImage.is_show === true 
    ? {
    backgroundImage: `url(${bottomImage.big && bottomImage.big[0]?.img})`
  }
    : {
    paddingBottom: 10
  }
  console.log('iconstyle', iconstyle);
  return (
    <div className={style.container}>
      <div>
        <img className={style.img} src={meetinginfo?.cover || ''} alt="" />
      </div>
      <div className={style.infoBox}>
        <div className={style.title}>
          {meetinginfo ? meetinginfo.title : '加载中...'}
        </div>
        <div className={style.meetingBox}>
          <div className={style.timeAndAddrBox}>
            <div className={style.time}>
              {meetinginfo ? meetinginfo.strat_time : '加载中...'}{meetinginfo ? meetinginfo.strat_time_week : ''}
            </div>
            <div>
              {meetinginfo ? meetinginfo.address : '加载中...'}
            </div>
          </div>
        </div>
        {showRegisterButton && (
          <div
            style={{ position: 'absolute', right: 12, bottom: 30}}
            onClick={onRegister}
          >
            <div className={style.button}>
              参加报名
              <Icon type='right' />
            </div>
          </div>
        )}
      </div>
      <div 
        className={style.icons}
        style={{...iconstyle}}
      >
        <div style={{minHeight: '300px'}}>
          <Grid
            data={modelList}
            columnNum={3}
            square={false}
            hasLine={false}
            itemStyle={{height: '150px'}}
            onClick={(item: any, index) => {
              // 如果需要注册 且没注册 则跳转到注册
              if (item.is_register === true && userstatus.user_is_register === false) {
                history.push(`/home/register/${params.id}`);
                return;
              }

              switch (item.type) {
                case "outlink":
                  window.location.href = item.content.url;
                  break;
                case "article":   //16 19
                  window.location.hash = `#/home/article/${params.id}/` + item.content.id;
                  break;
                case "tools":
                  alert("工具：" + JSON.stringify(item));
                  break;
                default:
                  alert("未知选项");
              }
            }}
            renderItem={(item: any) => (
              <div className={style.listItem}>
                <div className={style.itemImgBox}>
                  <div className={style.iconBox}>
                    <img className={style.itemImg} src={item.icon} alt="" />
                  </div>
                </div>
                <div className={style.itemText}>{item.title}</div>
              </div>
            )}
          />
        </div>

      </div>
      <div className={style.copyright} style={{ display: "none" }}>
        会佰分™ 提供技术支持
      </div>
    </div>
  )
}